import './EducationPage.css';
import { Link } from 'react-router-dom';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';

const educationalFiles = [
  {
    fileName: 'Основные сведения.pdf',
    label: 'Раздел 1',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
  {
    fileName: 'Структура и органы управления образовательной организацией.pdf',
    label: 'Раздел 2',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
  {
    fileName: 'Документы.pdf',
    label: 'Раздел 3',
    actionLabel: 'Открыть документы',
    href: '/education/documents/',
    isExternal: false,
  },
  {
    fileName: 'Образование.pdf',
    label: 'Раздел 4',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
  {
    fileName: 'Руководство. Педагогический (научно-педагогический) состав.pdf',
    label: 'Раздел 5',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
  {
    fileName: 'Материально-техническое обеспечение и оснащённость образовательного процесса.pdf',
    label: 'Раздел 6',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
  {
    fileName: 'Платные образовательные услуги .pdf',
    label: 'Раздел 7',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
  {
    fileName: 'Финансово-хозяйственная деятельность.pdf',
    label: 'Раздел 8',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
  {
    fileName: 'Вакантные места для приёма (перевода).pdf',
    label: 'Раздел 9',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
  {
    fileName: 'Стипендии и иные виды материальной поддержки.pdf',
    label: 'Раздел 10',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
  {
    fileName: 'Образовательные стандарты.pdf',
    label: 'Раздел 11',
    actionLabel: 'Открыть файл',
    isExternal: true,
  },
];

function EducationPage() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="educationPage">
          <div className="educationPage__hero">
            <h2 className="educationPage__title">
              Сведения об образовательной деятельности
            </h2>
            <p className="educationPage__lead">
              В разделе размещены основные документы и материалы, связанные с
              образовательной деятельностью Самарского областного отделения
              ВДПО.
            </p>
          </div>

          <div className="educationPage__list">
            {educationalFiles.map((item) => (
              <article className="educationPage__card" key={item.fileName}>
                <div className="educationPage__card-content">
                  <p className="educationPage__card-number">{item.label}</p>
                  <h3 className="educationPage__card-title">
                    {item.fileName.replace(/\.(pdf)$/i, '').trim()}
                  </h3>
                </div>
                <div className="educationPage__card-actions">
                  {item.isExternal ? (
                    <a
                      href={
                        item.href ??
                        `/images/vdpo_educational/${encodeURIComponent(item.fileName)}`
                      }
                      className="educationPage__card-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.actionLabel}
                    </a>
                  ) : (
                    <Link to={item.href} className="educationPage__card-link">
                      {item.actionLabel}
                    </Link>
                  )}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default EducationPage;
